import { EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
var CommentStepComponent = /** @class */ (function () {
    function CommentStepComponent() {
        this.nextStepEvent = new EventEmitter();
    }
    CommentStepComponent.prototype.ngOnInit = function () {
    };
    CommentStepComponent.prototype.nextStep = function () {
        this.nextStepEvent.emit({
            nextStep: 'final-step',
            comment: this.commentForm.value
        });
    };
    return CommentStepComponent;
}());
export { CommentStepComponent };
